import blogCImg1 from "../../assets/blog/blog1.png"
import blogCImg2 from "../../assets/blog/blog2.png"
import blogCImg3 from "../../assets/blog/blog3.png"
import blogAuthor from "../../assets/blog/author.jpeg"
import clock from "../../assets/blog/clock.png"
import calendar from "../../assets/blog/calendar.png"
import placeholder from "../../assets/blog/placeholder.png"

const assets = {
    clock,
    calendar,
    placeholder
}

export const blogCards = [
    {
        id: 1,
        image: blogCImg1,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
    {
        id: 2,
        image: blogCImg2,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
    {
        id: 3,
        image: blogCImg3,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
    {
        id: 4,
        image: blogCImg3,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
    {
        id: 5,
        image: blogCImg3,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
    {
        id: 2,
        image: blogCImg2,
        tag: "Travel",
        cardTitle: "Warm and humid, a sticky day",
        authorName: "John Doe",
        authorImg: blogAuthor,
        postDate: "02 december 2022",
        desc: "Bring to the table win- win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has evolved from generation.",
    },
]

export default assets;